import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import FileSaver from 'file-saver';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { TciInfoDto } from '../../template-for-certificate-issuance/DTO/tciInfoDto.model';
import { TciInfoSearchingDto } from '../../template-for-certificate-issuance/DTO/tciInfoSearchingDto.model';
import { TciInfoStorageService } from '../../template-for-certificate-issuance/services/tci-info-storage.service';
import { TamOccupation } from '../../training-and-assessment-materials/models/tam-occupation.model';
import { TrainingAndAssessmentMaterialsStorageService } from '../../training-and-assessment-materials/services/training-and-assessment-materials-storage.service';
import { TrainingAndAssessmentMaterialsService } from '../../training-and-assessment-materials/services/training-and-assessment-materials.service';
import { RplStorageService } from '../../stp-operations/services/rpl-storage.service';
import { RegularAssessmentService } from '../../stp-operations/services/regular-assessment.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { environment } from 'src/environments/environment';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { CertificateService } from 'src/app/shared/services/certificate.service';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-download-certificate',
  templateUrl: './download-certificate.component.html',
  styleUrls: ['./download-certificate.component.scss'],
})
export class DownloadCertificateComponent implements OnInit {
  clickEventSubscription: Subscription;
  tciInfoList: TciInfoDto[] = [];
  total: number;
  size: number = 10;
  page: number = 1;
  onTciInfoSubscription$: Subscription;
  tciInfoFiltered: TciInfoDto[] = [];
  tamOccupations: TamOccupation[] = [];
  onTamOccupationSubscription$: Subscription;
  searchingForm: FormGroup = this.fb.group({
    occupationNameEnglish: [null],
    level: [''],
    registrationNo: [''],
    email: [''],
    contact: [
      '',
      [
        Validators.maxLength(11),
        Validators.minLength(11),
        Validators.pattern(/^[0-9]*$/),
      ],
    ],
    certificateSerialNo: [''],
  });

  contentVisble = false;

  constructor(
    private tciInfoStorageService: TciInfoStorageService,
    private notification: NzNotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private trainingAndAssessmentMaterialsService: TrainingAndAssessmentMaterialsService,
    private trainingAndAssessmentMaterialsStorageService: TrainingAndAssessmentMaterialsStorageService,
    private regularAssessmentService: RegularAssessmentService,
    private rplStorageService: RplStorageService,
    private certificateService: CertificateService,
  ) {}

  ngOnInit(): void {}

  onSearch() {
    let regNo = this.searchingForm.get('registrationNo')?.value;
    let email = this.searchingForm.get('email')?.value;
    let contact = this.searchingForm.get('contact')?.value;
    let certificateSerialNo = this.searchingForm.get(
      'certificateSerialNo'
    )?.value;

    if (!regNo && !email && !contact && !certificateSerialNo) {
      this.notification.error(
        'Error!',
        'Atleast one search criteria is required'
      );
      this.tciInfoList = [];
    } else {
      this.page = 1;
      this.size = 10;
      this.getAllCertificates(this.searchingForm.value);
    }
  }

  getAllCertificates(tciFilteringRequestData?: TciInfoSearchingDto): void {
    this.tciInfoStorageService
      .getAllCertificates(this.page, this.size, tciFilteringRequestData)
      .subscribe({
        next: (res) => {
          this.tciInfoList = res.data;
          this.total = res.count;
        },
      });
  }

  ngOnDestroy(): void {
    this.onTciInfoSubscription$?.unsubscribe();
  }

  onRefresh() {
    this.page = 1;
    this.size = 10;
    this.searchingForm.reset();
    this.tciInfoList = [];
    this.total = 0;
  }

  onDownloadCertificate(data: any) {
    console.log(data);

    let com = data.isCompetent ? true : false;
    //Regular Batch Assessment
    if (data?.certificateType == 2) {
      this.regularAssessmentService
        .onCollectdataToDownloadCertificate(data.id)
        .subscribe({
          next: (res: any) => {
            if (
              !res ||
              typeof res !== 'object' ||
              (Array.isArray(res) && res.length === 0)
            ) {
              this.notification.warning(
                'Warning!!!',
                'Unable to proceed: No valid data found for certificate generation.'
              );
              return;
            }

            res['isCompetent'] = com;
            this.certificateService.fetchDataFromTCIAndDownloadCertificate(res);
          },
          error: (error) => {
            console.error('Error fetching certificate data:', error);
            this.notification.warning(
              'Warning!!!',
              'Failed to retrieve data. Please try again.'
            );
          },
        });
    } else if (data?.certificateType == 1) {
      //Rpl Batch Assessment
      this.rplStorageService
        .onCollectdataToDownloadCertificate(data.id)
        .subscribe({
          next: (res: any) => {
            if (
              !res ||
              typeof res !== 'object' ||
              (Array.isArray(res) && res.length === 0)
            ) {
              this.notification.warning(
                'Warning!!!',
                'Unable to proceed: No valid data found for certificate generation.'
              );
              return;
            }

            res['isCompetent'] = com;
            this.certificateService.fetchDataFromTCIAndDownloadCertificateRPL(res);
          },
          error: (error) => {
            console.error('Error fetching certificate data:', error);
            this.notification.warning(
              'Warning!!!',
              'Failed to retrieve data. Please try again.'
            );
          },
        });
    } else {
      // TCI
      this.tciInfoStorageService
        .downloadFreelancerCertificate(data.id)
        .subscribe({
          next: (response: ServerResponse) => {
            if (!response?.success || !response?.data) {
              this.notification.warning(
                'Warning!!!',
                'Certificate data is missing or invalid.'
              );
              return;
            }
            this.certificateService.onFreelancerCertificateDownload(response.data);
          },
          error: (error: any) => {
            console.error('Error downloading frelancer certificate:', error);
            this.notification.error(
              'Error',
              'Failed to download frelancer certificate. Please try again.'
            );
          },
        });
    }
  }

  // certificateDownloadForBothRplRegular(data: any){
  //   this.rplStorageService.downloadCertificateForRpl(data).subscribe((data: any) => {
  //     var fileName = 'report.pdf';
  //     const contentDisposition = data.headers.get('Content-Disposition');
  //     if (contentDisposition) {
  //       const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  //       const matches = fileNameRegex.exec(contentDisposition);
  //       if (matches != null && matches[1]) {
  //         fileName = matches[1].replace(/['"]/g, '');
  //       }
  //     }
  //     FileSaver(data.body, fileName);
  //   })
  // }

  onCertificateView(data: any) {
    this.router.navigate(['certificate-view', data.id], {
      relativeTo: this.activatedRoute,
    });
  }

  getOccupationList() {
    this.tamOccupations =
      this.trainingAndAssessmentMaterialsService.getTamOccupations();

    if (this.tamOccupations.length === 0) {
      this.trainingAndAssessmentMaterialsStorageService
        .readTamOccupations()
        .subscribe();
    }
    this.onTamOccupationSubscription$ =
      this.trainingAndAssessmentMaterialsService.onRefreshTamOccupationList.subscribe(
        (res) => {
          this.tamOccupations = res;
        }
      );
  }

  captchVerificationStatus(verificationStatus: {
    success: boolean;
    message: string;
  }) {
    if (verificationStatus.success) {
      this.notification.success('Success', verificationStatus.message);
      this.contentVisble = true;
    } else {
      this.notification.error('Error', verificationStatus.message);
      this.contentVisble = false;
    }
  }

onPageChange(pageIndex: number): void {
  this.page = pageIndex;
  this.getAllCertificates(this.searchingForm.value);
}

onPageSizeChange(pageSize: number): void {
  this.size = pageSize;
  this.page = 1;
  this.getAllCertificates(this.searchingForm.value);
}

}
